import React from "react"
import IntersectionLazyLoader from "../intersection-lazy-loader/intersectionLazyLoader";

interface Props {
    locations: Array<any>;
}

export const LocationsLazyLoad = ({ locations }: Props) => {

    const Locations = React.lazy(() => import("./locations"));

    return (
        <IntersectionLazyLoader beforeLoad={<>TODO</>}><Locations locations={locations} /></IntersectionLazyLoader>
    )
}

LocationsLazyLoad.NAME = "LocationsLazyLoad";
export default LocationsLazyLoad
